export class EditProjectRoleDto {
    roleId = 0;
    structurePath: string;
    userId = 0;
    overwrite = false;
}
